import { DocItemModal5 } from "features/DocItemModal/DocItemModalComponents/DocItemModal5";
import { DocItemModal1 } from "features/DocItemModal/DocItemModalComponents/DocItemModal1";
import { DocItemModal2 } from "features/DocItemModal/DocItemModalComponents/DocItemModal2";
import { DocItemModal3 } from "features/DocItemModal/DocItemModalComponents/DocItemModal3";
import { DocItemModal6 } from "features/DocItemModal/DocItemModalComponents/DocItemModal6";
import { DocItemModal4 } from "features/DocItemModal/DocItemModalComponents/DocItemModal4";
import { DocItemModal9 } from "features/DocItemModal/DocItemModalComponents/DocItemModal9";
import { DocItemModal8 } from "features/DocItemModal/DocItemModalComponents/DocItemModal8";
import { DocItemModal7 } from "features/DocItemModal/DocItemModalComponents/DocItemModal7";

import {
  EDocumentsMainFilters,
  EDocumentsModalDataType,
  TDocBottomRows,
  TDocItem,
  TDocItemsBottomRows,
  TDocItemToDraw,
  TDocumentsData,
  TDocumentsOperation,
} from "../types/documents";

const DocumentsOperations: TDocumentsOperation[] = [
  {
    id: "1",
    name: "Продажи",
    include: true,
  },
  {
    id: "2",
    name: "Возврата",
    include: true,
  },
  {
    id: "3",
    name: "Списания",
    include: true,
  },
  {
    id: "4",
    name: "Уценки",
    include: true,
  },
  {
    id: "5",
    name: "Поступления",
    include: true,
  },
  {
    id: "6",
    name: "Перемещения",
    include: true,
  },
  {
    id: "7",
    name: "Возврата поставщику",
    include: true,
  },
  {
    id: "8",
    name: "Инвентаризации",
    include: true,
  },
  {
    id: "9",
    name: "Оприходования",
    include: true,
  },
  {
    id: "62",
    name: "Перемещения (приход)",
  },
  {
    id: "41",
    name: "Переоценки (приход)",
  },
  {
    id: "10",
    name: "Приходного ордера",
  },
  {
    id: "11",
    name: "Расходного ордера",
  },
  {
    id: "12",
    name: "Установки цен",
  },
  {
    id: "13",
    name: "Собранный букет",
  },
  {
    id: "131",
    name: "Комплектация (приход)",
  },
  {
    id: "14",
    name: "Перемещение денег",
  },
  {
    id: "141",
    name: "Перемещение денег (приход)",
  },
  {
    id: "132",
    name: "Закрытые букеты",
  },
  {
    id: "133",
    name: "Букет в счете",
  },
  /*  {
    id: "15",
    name: "Уценки",
  },*/
  {
    id: "16",
    name: "Перемещение букетов",
  },
  {
    id: "134",
    name: "Перемещеный букет",
  },
  {
    id: "135",
    name: "Отправленный букет",
  },
  {
    id: "136",
    name: "Полученные букеты",
  },
  {
    id: "501",
    name: "Удаленный чек продажи",
  },
  {
    id: "502",
    name: "Удаленный чек возврата",
  },
  {
    id: "503",
    name: "Удаленный чек списания",
  },
  {
    id: "513",
    name: "Удаленный букет",
  },
  {
    id: "137",
    name: "Списанный букет",
  },
  {
    id: "17",
    name: "Платежное поручение входящее",
  },
  {
    id: "18",
    name: "Платежное поручение входящее",
  },
  {
    id: "19",
    name: "Счет покупателю",
  },
  {
    id: "20",
    name: "Заказ поставщику",
  },
  {
    id: "21",
    name: "Заказ на склад",
  },
  {
    id: "140",
    name: "Перемещенный заказ",
  },
  {
    id: "22",
    name: "Инвойс",
  },
  {
    id: "23",
    name: "Акт сверки",
  },
];

const DocBottomRows: TDocBottomRows = {
  "1": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "2": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "3": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "4": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "5": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "6": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "7": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "8": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "9": ({ documentsToDraw = [] }) => ({
    docid: -1,
    isConducted: -1,
    total: documentsToDraw.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
};

const DocItemsBottomRows: TDocItemsBottomRows = {
  "1": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
    total: filteredDocItems.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "2": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
    total: filteredDocItems.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "3": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
  }),
  "4": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
  }),
  "5": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
    total: filteredDocItems.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "6": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
  }),
  "7": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
    total: filteredDocItems.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
  "8": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    realamount: filteredDocItems.reduce((acc, i) => acc + +i.realamount, 0),
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
    difference:
      filteredDocItems.reduce((acc, i) => acc + +i.amount, 0) -
      filteredDocItems.reduce((acc, i) => acc + +i.realamount, 0),
  }),
  "9": ({ filteredDocItems = [] }) => ({
    docitemid: -1,
    index: filteredDocItems.length,
    amount: filteredDocItems.reduce((acc, i) => acc + +i.amount, 0),
    total: filteredDocItems.reduce((acc, i) => acc + +i.total, 0).toFixed(2),
  }),
};

const DocumentsData: TDocumentsData = {
  "1": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Сумма",
        field: "total",
        width: 150,
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 50,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Артикул",
        field: "itemcode",
        width: 90,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 90,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 90,
      },
      {
        headerName: "Цена, ₽",
        field: "price",
        width: 120,
      },
      {
        headerName: "Итого, ₽",
        field: "total",
        width: 120,
      },
      {
        headerName: "Скидка, ₽",
        field: "discountsum",
        width: 120,
      },
      {
        headerName: "Скидка клиента, ₽",
        field: "clientdiscountsum",
        width: 120,
      },
      {
        headerName: "Комментарий",
        field: "itemcomment",
        width: 240,
      },
    ],
    bottomRow: DocBottomRows["1"],
    modalBottomRow: DocItemsBottomRows["1"],
    modalModalComponent: <DocItemModal1 />,
  },
  "2": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Сумма",
        field: "total",
        width: 150,
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 120,
      },
      {
        headerName: "Цена, ₽",
        field: "price",
        width: 120,
      },
      {
        headerName: "Итого, ₽",
        field: "total",
        width: 120,
      },
    ],
    bottomRow: DocBottomRows["2"],
    modalBottomRow: DocItemsBottomRows["2"],
    modalModalComponent: <DocItemModal2 />,
  },
  "3": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 50,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 90,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 90,
      },
    ],
    bottomRow: DocBottomRows["3"],
    modalBottomRow: DocItemsBottomRows["3"],
    modalModalComponent: <DocItemModal3 />,
  },
  "4": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Из товара",
        field: "item",
        width: 120,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 120,
      },
      {
        headerName: "В товар",
        field: "item2",
        width: 120,
      },
      {
        headerName: "Ед. изм.",
        field: "measure2",
        width: 120,
      },
    ],
    bottomRow: DocBottomRows["4"],
    modalBottomRow: DocItemsBottomRows["4"],
    modalModalComponent: <DocItemModal4 />,
  },
  "5": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Сумма",
        field: "total",
        width: 150,
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Не изменять продажные цены",
        type: EDocumentsModalDataType.priceupdated,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 120,
      },
      {
        headerName: "Цена, ₽",
        field: "price",
        width: 120,
      },
      {
        headerName: "Итого, ₽",
        field: "total",
        width: 120,
      },
      {
        headerName: "Прайслист",
        field: "pricelist",
        width: 120,
      },
      {
        headerName: "Пр. цена",
        field: "frontprice",
        width: 120,
      },
      {
        headerName: "% наценки",
        field: "salepercent",
        width: 120,
      },
    ],
    bottomRow: DocBottomRows["5"],
    modalBottomRow: DocItemsBottomRows["5"],
    modalModalComponent: <DocItemModal5 />,
  },
  "6": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.store2,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Склад-получатель",
        field: "stock2",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Склад-получатель",
        type: EDocumentsModalDataType.store2,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Артикул",
        field: "itemcode",
        width: 90,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 120,
      },
    ],
    bottomRow: DocBottomRows["6"],
    modalBottomRow: DocItemsBottomRows["6"],
    modalModalComponent: <DocItemModal6 />,
    shouldCheck2Stores: true,
  },
  "7": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Сумма",
        field: "total",
        width: 150,
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 120,
      },
      {
        headerName: "Цена, ₽",
        field: "price",
        width: 120,
      },
      {
        headerName: "Итого, ₽",
        field: "total",
        width: 120,
      },
    ],
    bottomRow: DocBottomRows["7"],
    modalBottomRow: DocItemsBottomRows["7"],
    modalModalComponent: <DocItemModal7 />,
  },
  "8": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Артикул",
        field: "itemcode",
        width: 90,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во учёт",
        field: "realamount",
        width: 120,
      },
      {
        headerName: "Кол-во факт + букет",
        field: "amount",
        width: 180,
      },
      {
        headerName: "Расхождение",
        field: "difference",
        width: 140,
      },
    ],
    bottomRow: DocBottomRows["8"],
    modalBottomRow: DocItemsBottomRows["8"],
    modalModalComponent: <DocItemModal8 />,
  },
  "9": {
    mainFilters: [
      EDocumentsMainFilters.dateFrom,
      EDocumentsMainFilters.dateTo,
      EDocumentsMainFilters.store,
      EDocumentsMainFilters.search,
    ],
    mainColumns: [
      {
        headerName: "Проведён",
        field: "isConducted",
        width: 150,
      },
      {
        headerName: "Номер",
        field: "number",
        width: 150,
      },
      {
        headerName: "Дата документа",
        field: "creationTime",
      },
      {
        headerName: "Сумма",
        field: "total",
        width: 150,
      },
      {
        headerName: "Склад",
        field: "stock",
      },
      {
        headerName: "Комментарий",
        field: "comment",
      },
    ],
    modalData: [
      {
        name: "№ документа:",
        type: EDocumentsModalDataType.textPointer,
        field: "docid",
      },
      {
        name: "Склад",
        type: EDocumentsModalDataType.store,
      },
      {
        name: "Дата",
        type: EDocumentsModalDataType.date,
      },
      {
        name: "Время",
        type: EDocumentsModalDataType.time,
      },
      {
        name: "Комментарий",
        type: EDocumentsModalDataType.comment,
      },
    ],
    modalColumns: [
      {
        headerName: "№",
        field: "index",
        width: 100,
      },
      {
        headerName: "Товар",
        field: "item",
        width: 190,
      },
      {
        headerName: "Ед. изм.",
        field: "measure",
        width: 120,
      },
      {
        headerName: "Кол-во",
        field: "amount",
        width: 120,
      },
      {
        headerName: "Цена, ₽",
        field: "price",
        width: 120,
      },
      {
        headerName: "Итого, ₽",
        field: "total",
        width: 120,
      },
    ],
    bottomRow: DocBottomRows["9"],
    modalBottomRow: DocItemsBottomRows["9"],
    modalModalComponent: <DocItemModal9 />,
  },
};

export { DocumentsOperations, DocumentsData };
